import { FileUploadError } from "./FileUploadError";

export const prevalidateFile = (file: File): FileUploadError | undefined => {
  if (file.size === 0) {
    return "FILE_EMPTY";
  }

  return;
};
